// extracted by mini-css-extract-plugin
export default {"container":"UserManagement_container__R1ex3","fadeIn":"UserManagement_fadeIn__kkXHf","grid":"UserManagement_grid__L8MSf"};